import { useCallback } from 'react';

import { defineMessages, useIntl } from 'react-intl';

import DarkModeIcon from '@/material-icons/400-24px/dark_mode.svg?react';
import LightModeIcon from '@/material-icons/400-24px/light_mode.svg?react';
import { changeColorScheme } from 'mastodon/actions/color_scheme';
import { Icon } from 'mastodon/components/icon';
import { useTheme } from 'mastodon/hooks/useTheme';
import { useAppDispatch } from 'mastodon/store';

const messages = defineMessages({
  switchToDark: {
    id: 'theme_toggle.switch_to_dark',
    defaultMessage: 'Switch to dark mode',
  },
  switchToLight: {
    id: 'theme_toggle.switch_to_light',
    defaultMessage: 'Switch to light mode',
  },
});

export const ThemeToggle: React.FC = () => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const isDark = theme === 'dark';

  const handleClick = useCallback(() => {
    const next = isDark ? 'light' : 'dark';

    document.documentElement.dataset.colorScheme = next;
    delete document.documentElement.dataset.systemTheme;

    dispatch(changeColorScheme(next));
  }, [dispatch, isDark]);

  const label = intl.formatMessage(
    isDark ? messages.switchToLight : messages.switchToDark,
  );

  return (
    <button
      type='button'
      className='icon-button theme-toggle'
      onClick={handleClick}
      title={label}
      aria-label={label}
    >
      <Icon
        id={isDark ? 'sun' : 'moon'}
        icon={isDark ? LightModeIcon : DarkModeIcon}
      />
    </button>
  );
};
